{
  "admins": {
    "errors": {
      "add": "Hindi na-add ang admin.",
      "notFound": "Hindi nahanap ang admin na iyon."
    }
  },
  "home": {
    "goToSandbox": "Pumunta sa sandbox",
    "subtitle": "Ang repo na ito ay starting point para sa pagbuo ng web apps gamit ang React, shadcn-ui at TanStack Router.",
    "title": "Maligayang pagdating sa Mindsea React Template."
  },
  "login": {
    "errors": {
      "invalidEmail": "Mangyaring maglagay ng wastong email address.",
      "unauthorized": "Hindi ka awtorisadong mag-access sa application na ito."
    },
    "placeholder": "email@halimbawa.com",
    "sendCode": "Ipadala ang code",
    "subtitle": "I-build ang login page dito.",
    "title": "Login"
  }
}
